import type { FaireProductEntity } from "../../entity_types/product";

export const p_yrefr6anbd: FaireProductEntity = {
  token: "p_yrefr6anbd",
  type: "product",
  name: "Bee Clean Organic Beeswax Hand Sanitizer - Mini Case",
  brandToken: "b_zkxn3dn2pw",
  brandName: "Bee Clean",
  imageUrl: "https://cdn.faire.com/fastly/fbd5dd3d23d599888aa8df65cc162b0df761e23a6c9288b3612b187d24614ca4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e52dba93d719c8014cb1e6783eeba618d364df2e9a9d93bfebe39de4b8067fc1.png",
    "https://cdn.faire.com/fastly/2a1efb684b697296a40df30ef488d20e2700a2f12cc78a75f8545906977b88c2.png",
    "https://cdn.faire.com/fastly/c7731f6d7d20c76cae2a5bb26dcc9145a0f35d3e606aef6bef98da6093bafdd5.png",
    "https://cdn.faire.com/fastly/890d97089b49878e1dfb95f3e260aa8754d0a34db6f912ef6921634bf71cc7d2.jpeg",
    "https://cdn.faire.com/fastly/f782e52af5ec2e55b3396f0d6eacf6819bb54257b2753e09804e4f137fe32851.jpeg",
    "https://cdn.faire.com/fastly/70a32655607e5dbaa519ef0ccb666c451e3e5f32379f5d15324903d9f3477b09.png",
    "https://cdn.faire.com/fastly/24f950c7cfe30784c88897ea582ed4f9cdecb9995d387eb46f9e6e3edc2dbb59.png",
    "https://cdn.faire.com/fastly/3564876060dc73facf17194212aab97c2225993065073ee80a8317182196d4db.png",
    "https://cdn.faire.com/fastly/133493714273d70056250d8bfe71572dab7e61ebc4724da63cd5d1b7ead35445.png",
    "https://cdn.faire.com/fastly/c53fefb9b0297264232fca7a270dc57a1104f1eaeeefdfc8b4f4c4fb66b4380d.png",
    "https://cdn.faire.com/fastly/9448b649f557777723be47d1d6301977ea576ef220a643d1745b53726e6d14af.png",
    "https://cdn.faire.com/fastly/01b2c56c3cb4f3197bced7643c2c86e0cd75c528a6700f81a488d573fcfca51a.jpeg",
    "https://cdn.faire.com/fastly/ec65ab040dd626edf93f544c7a38f3d464ce9a52ad194d381f62ae249c6f6a9b.jpeg",
    "https://cdn.faire.com/fastly/341ad75342bed061165e538f3c887f89abc971a4ab3eaf093a37a4b912bb8c3c.png",
    "https://cdn.faire.com/fastly/55df81be03f2cf8597dff186c13a106d8b75073a707420d6ab7abb6a7956fadc.png",
    "https://cdn.faire.com/fastly/c3e87886d1508cac08f2914028b3656b2f919c28fd71a4c4db8feb6d62b816a3.jpeg",
    "https://cdn.faire.com/fastly/4f00aad617c62e4c1b63ff83f2e4cb42aed2d02d4b0c7f78f89a889164046187.png",
    "https://cdn.faire.com/fastly/165a181c7a481fa2925c5cf51370e8aeb1bc82396f3c1c2ea8a8f181272b145c.jpeg",
    "https://cdn.faire.com/fastly/442a1e63414962ad54c45ef7b8572494606286e3da01059b253a27466d518a2f.jpeg"
  ],
  priceDollars: 3.81,
  description: "Bee Clean Beeswax Hand Sanitizers help you stay healthy and humming by killing germs with kinder, 100% organic and natural ingredients. Our spray-on mist is mess free via our convenient, innovative, recyclable packaging. Bee Clean contains natural antimicrobial peptides and organic ethyl alcohol to kill 99.9% of germs. It moisturizes using beeswax, vitamin E, avocado oil and apricot seed oil so hands feel soft and dry with no sticky residue. Our refreshing citrus peppermint and lavender essential oil scents are light and revitalizing. Bee Clean is proudly made in the USA and a NM True Certified product. This mini case contains four counter display units with 12 hand sanitizers a piece (6 Citrus & Peppermint and 6 Lavender) for a total of 48 units (24 Citrus Peppermint and 24 Lavender scent are included).",
  tags: [],
  msrpDollars: 7.62,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:10.328Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
